import type { TemplatesV2Response, FilteredTemplate } from './types.tsx';

const NUM_TEMPLATES_TO_DISPLAY = 5;

// note: these 4 templates are hardcoded for the time being
const TEMPLATE_KEYS = new Set([
	'jwm.blank-project',
	'jwm.project-management',
	'jwm.personal-task-planner',
	'jwm.task-tracking',
]);

export const getFilteredTemplates = (response: TemplatesV2Response) => {
	const {
		templates,
		lastUsedTemplate: lastUsedTemplateKey,
		recommendedTemplate: recommendedTemplateKey,
		recommendedTemplates: recommendedTemplateKeys,
	} = response;
	const lastUsedTemplates: FilteredTemplate[] = [];
	const recommendedTemplates: FilteredTemplate[] = [];
	const additionalTemplates: FilteredTemplate[] = [];

	recommendedTemplateKeys?.forEach((key, index) => {
		const template = templates.find((t) => t.key === key);

		if (template) {
			const { projectTypeTemplates } = template;

			// * The first recommended template will be the last used template if there is one
			if (index === 0 && lastUsedTemplateKey) {
				const isLastUsed =
					lastUsedTemplateKey &&
					(projectTypeTemplates?.teamManaged?.key === lastUsedTemplateKey ||
						projectTypeTemplates?.companyManaged?.key === lastUsedTemplateKey);

				lastUsedTemplates.push({ ...template, ...(isLastUsed && { isLastUsed }) });

				return;
			}

			const isRecommended =
				recommendedTemplateKey &&
				(projectTypeTemplates?.teamManaged?.key === recommendedTemplateKey ||
					projectTypeTemplates?.companyManaged?.key === recommendedTemplateKey);

			recommendedTemplates.push({
				...template,
				...(isRecommended && { isRecommended }),
			});
		}
	});

	// * If there are not enough templates to display, add additional templates
	if (lastUsedTemplates.length + recommendedTemplates.length < NUM_TEMPLATES_TO_DISPLAY) {
		// * Get the keys of the templates that are not last used or recommended
		const placeholderTemplateKeys = Array.from(TEMPLATE_KEYS).filter(
			(key) =>
				!lastUsedTemplates.some((t) => t.key === key) &&
				!recommendedTemplates.some((t) => t.key === key),
		);

		templates.forEach((template) => {
			if (placeholderTemplateKeys.includes(template.key)) {
				additionalTemplates.push(template);
			}
		});
	}

	// templates are sorted in order of last used, recommended and fallback.
	// only use the first 5 templates
	const filteredTemplates = [
		...lastUsedTemplates,
		...recommendedTemplates,
		...additionalTemplates,
	].slice(0, NUM_TEMPLATES_TO_DISPLAY);

	return filteredTemplates;
};
